(function () {
    "use strict";

    Components.QuickbooksRedirect = {
        controller: "QuickbooksRedirectController",
        name: "hbQuickbooksRedirect",
        templateUrl:
            "angular/app/modules/core/features/quickbooks_integration/quickbooks_redirect_page_template.html",
    };
})(); 